<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs">
		<div class="modalWrapper kingdomUnionSuccess " style="opacity: 1; align-items: center; justify-content: center; display: flex; width: 100%; height: 100%;">
			<div class="modal kingdomUnionSuccess" style="top: 0;">
				<div class="modalContent" ng-style="{minHeight: w.getOverlayHeightWithPadding(-10) || 'none'}">
					<div class="windowHeadlineDecoration kingdomUnion_windowHeader contentHeader">
						<h2 class=" msAntiScroll" draggable="true">
							<span translate="" options="KingdomUnionSuccess.Title" data=""><span>Объединенное королевство</span></span>
						</h2>
					</div>
					<div class="functionBar">
						<div class="functionPanel">
							<a ng-if="w.params.modalParams.closeable" clickable="closeWindow('kingdomUnionSuccess')" class="closeWindow clickable" @click="onModalClose(close)" play-on-click="7">
								<i class="action_cancel_small_flat_black"></i>
							</a>
						</div>
					</div>
					<div class="content">
						<div ng-controller="kingdomUnionSuccessCtrl" class="kingdomUnionSuccess">
							<div class="playerInfo kingdomUnion_background">
								<div ng-if="kingPlayerId" class="playerProfileAvatar kingdomRole1">
									<div class="headerWithArrowEndings kingdomRole kingdomRole1">
										<div class="content"><span class="truncated">Брего</span></div>
									</div>
									<div class="avatarLink clickable" clickable="openWindow('profile', {'playerId': kingPlayerId, 'profileTab': 'playerProfile'}, null, true)">
										<avatar-image scale="0.55" class="avatarImage" player-id="106" size="big" avatar-class="profileImage">
											<div class="heroImage  profileImage male" ng-class="::class" rerender="rerender">
												<!-- ngIf: playerId == robberId -->
												<!-- ngIf: playerId == npcGovernorId -->
												<canvas width="192" height="193"></canvas>
											</div>
										</avatar-image>
									</div>
									<span class="decoration"></span>
								</div>
								<div ng-if="vicekingPlayerId" class="playerProfileAvatar kingdomRole3">
									<div class="headerWithArrowEndings kingdomRole kingdomRole3">
										<div class="content"><span class="truncated">Gaius Ulius</span></div>
									</div>
									<div class="avatarLink clickable" clickable="openWindow('profile', {'playerId': vicekingPlayerId, 'profileTab': 'playerProfile'}, null, true)">
										<avatar-image scale="0.55" class="avatarImage" player-id="127" size="big" avatar-class="profileImage">
											<div class="heroImage  profileImage male" ng-class="::class" rerender="rerender">
												<!-- ngIf: playerId == robberId -->
												<!-- ngIf: playerId == npcGovernorId -->
												<canvas width="192" height="193"></canvas>
											</div>
										</avatar-image>
									</div>
									<span class="decoration"></span>
								</div>
							</div>
							<p>
								<!-- ngIf: kingPlayerId && vicekingPlayerId --><span translate="" ng-if="kingPlayerId &amp;&amp; vicekingPlayerId" data="kingPlayerId: 106, vicekingPlayerId: 127, openKingdomChat: openChatTab(2), learnMore: openUnionsHelp()"><span>Поздравляем! Твое королевство успешно объединилось с другим, чтобы расширить границы своих владений. Твой новый король </span><a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="truncated playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" playerid="106" playername="Брего" nolink="" showmissinglink="true">Брего</a><span> и вице-король </span><a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="truncated playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" playerid="127" playername="Gaius Ulius" nolink="" showmissinglink="true">Gaius Ulius</a><span> соединили силы, чтобы стать еще успешнее. В качестве нового жителя королевства, не забудь посетить </span><translate clickable="openChatTab(2)" class="textLink clickable"><span>Чат королевства</span></translate><span> и </span><translate clickable="openWindow('igm', {}, null, true)" class="textLink clickable"><span>IGM</span></translate><span> для получения дальнейшей информации. Если хочешь узнать больше о слиянии королевств, загляни в нашу внутриигровую справку </span><translate clickable="openUnionsHelp()" class="textLink clickable"><span>Узнать больше</span></translate><span>.</span></span><!-- end ngIf: kingPlayerId && vicekingPlayerId -->
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		cancelHover: false,
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_1.ogg');
				audio.play();
			}
		},
		onModalClose(close){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_2.ogg');
				audio.play();
			}
			if(close) close();
		},
	},
	mounted(){
		this.onModalOpen();
	},
	beforeDestroy(){
		this.onModalClose();
	},
	components: {},
}
</script>